/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import s from './s.module.less';
import { EServiceType, TKlarityProgramItemDetail, TKlarityProgramPackageItem } from 'types/common';
import { mockConfigProgram } from 'utils/mockData';
import icon from './icon.svg';
import { Button, Switch } from 'antd';

type IProps = {
    data?: TKlarityProgramItemDetail;
};

const ServiceSelection = (props: IProps) => {
    const { data } = props;
    const items: TKlarityProgramPackageItem[] = [];

    const existPackageName: string[] = [];
    data?.klarityProgramPackageList?.forEach((item: TKlarityProgramPackageItem) => {
        if (!item.isKlarityDisplay || item.billingFrequencyType !== 'Monthly') {
            return;
        }
        const pName = item.packageTitle;
        if (!existPackageName.includes(pName)) {
            existPackageName.push(pName);
            items.push(item);
        }
    });
    return (
        <div className={s.wrap}>
            {
                items && items.length ? items.slice(0, 1).map((item, index) => {
                    const itemOneTime = data?.klarityProgramPackageList?.find((i) => i.packageTitle === item.packageTitle && i.billingFrequencyType === 'One-Time');
                    const hasOneTimeOff = !!itemOneTime && itemOneTime.totalPrice && item.totalPrice && itemOneTime.totalPrice < item.totalPrice;
                    // const firstPaymentPrice = item?.firstPaymentPrice - item?.price;

                    let patientCost = 99;
                    let firstPaymentPrice = 159;
                    let hasInPerson = false;
                    let hasTelehealth = false;

                    if (item.klarityProgramPackageSessionItemList) {
                        const sessionItem = item.klarityProgramPackageSessionItemList.find((i) => i.serviceType === EServiceType.INIT);

                        if (sessionItem) {
                            patientCost = sessionItem.patientCost || 0;
                            hasInPerson = !!sessionItem.inPerson;
                            hasTelehealth = !!sessionItem.teleHealth;

                            if (item?.firstPaymentPrice) {
                                firstPaymentPrice = (item.firstPaymentPrice || 0) - patientCost;
                            }
                        }
                    }
                    return (
                        <div className={s.item} key={item.id}>
                            <div className={s.itemInner}>
                                <div className={s.left}>
                                    <div className={s.spe}>
                                        {data?.specialtyName}
                                    </div>
                                    <div className={s.name}>
                                        {item.patientFacingTitle?.replace(/^\[.*?\]\s*/, '')}
                                    </div>
                                    {/* <div className={s.subName}>
                                    ({item.subName})
                                </div> */}
                                    <div className={s.info}>
                                        <span className={s.initPrice}>
                                            ${patientCost}
                                        </span>
                                        for provider visit (eligible for medication discount)
                                    </div>
                                    {
                                        hasOneTimeOff && (
                                            <div className={s.payoff}>
                                                Subscribe 3-month medications to get
                                                <span className={s.high}>
                                                    {/* one time的原价和monthly的原价不一样了，所以不能直接减 */}
                                                    {/* ${item.totalPrice - itemOneTime.totalPrice} off */}
                                                    $50 off
                                                </span>
                                                <span>
                                                    <Switch checked={false} />
                                                </span>
                                            </div>
                                        )
                                    }
                                    <div className={s.tInfo}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                            <path d="M8.62614 6.08614V8.95817L10.7802 11.1122M15.0882 8.95817C15.0882 12.5271 12.195 15.4202 8.62614 15.4202C5.05723 15.4202 2.16406 12.5271 2.16406 8.95817C2.16406 5.38926 5.05723 2.49609 8.62614 2.49609C12.195 2.49609 15.0882 5.38926 15.0882 8.95817Z" stroke="#6B7280" strokeWidth="1.43602" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        {item.firstPaymentDuration} mins
                                        {
                                            (hasInPerson || hasTelehealth) && (
                                                <>
                                                    <span className={s.split}>
                                                        |
                                                    </span>
                                                    {
                                                        hasInPerson && (
                                                            <div className={s.contactTypeItem}>
                                                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g id="Office building">
                                                                        <path id="Icon" d="M17.4167 19.25V4.58333C17.4167 3.57081 16.5959 2.75 15.5833 2.75H6.41667C5.40414 2.75 4.58333 3.57081 4.58333 4.58333V19.25M17.4167 19.25L19.25 19.25M17.4167 19.25H12.8333M4.58333 19.25L2.75 19.25M4.58333 19.25H9.16667M8.25 6.41665H9.16667M8.25 10.0833H9.16667M12.8333 6.41665H13.75M12.8333 10.0833H13.75M9.16667 19.25V14.6666C9.16667 14.1604 9.57707 13.75 10.0833 13.75H11.9167C12.4229 13.75 12.8333 14.1604 12.8333 14.6666V19.25M9.16667 19.25H12.8333" stroke="#6B7280" strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </g>
                                                                </svg>

                                                                In-person visit
                                                            </div>
                                                        )
                                                    }

                                                    {
                                                        hasTelehealth && (
                                                            <div className={s.contactTypeItem}>
                                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path id="Vector" fillRule="evenodd" clipRule="evenodd" d="M8.31277 1.52801H7.64986V4.35866C7.64986 4.91872 7.86873 5.45584 8.25833 5.85187C8.64792 6.24789 9.17633 6.47037 9.7273 6.47037C10.2783 6.47037 10.8067 6.24789 11.1963 5.85187C11.5859 5.45584 11.8047 4.91872 11.8047 4.35866V1.52801H11.1418C10.9425 1.52801 10.7513 1.44752 10.6104 1.30424C10.4694 1.16096 10.3902 0.966634 10.3902 0.764007C10.3902 0.56138 10.4694 0.367052 10.6104 0.223773C10.7513 0.0804935 10.9425 1.96927e-07 11.1418 1.96927e-07H11.8483C12.0399 -0.00010016 12.2296 0.0381578 12.4067 0.11259C12.5837 0.187021 12.7446 0.29617 12.8801 0.433802C13.0157 0.571435 13.1232 0.734856 13.1966 0.914736C13.27 1.09462 13.3079 1.28743 13.308 1.48217V4.35866C13.3078 5.18753 13.0293 5.99151 12.5186 6.63765C12.0078 7.28378 11.2954 7.73337 10.4992 7.91205C10.5788 8.53447 10.8885 9.10276 11.3653 9.50152C11.8422 9.90029 12.4505 10.0996 13.0666 10.0591C13.6828 10.0185 14.2607 9.74112 14.683 9.28319C15.1053 8.82526 15.3403 8.22112 15.3403 7.59346V6.43064C14.916 6.2667 14.5607 5.95831 14.335 5.55798C14.1092 5.15766 14.027 4.69017 14.1023 4.23514C14.1776 3.7801 14.4057 3.36567 14.7479 3.06243C15.09 2.75919 15.525 2.58589 15.9787 2.57205C16.4324 2.55822 16.8769 2.7047 17.2363 2.98655C17.5957 3.26839 17.8478 3.66818 17.9498 4.11781C18.0518 4.56743 17.9973 5.03909 17.7956 5.45245C17.5939 5.86581 17.2574 6.1953 16.8435 6.3848V7.59346C16.8422 8.62487 16.4489 9.61588 15.7458 10.3595C15.0426 11.1031 14.084 11.5417 13.0702 11.5839C12.0564 11.626 11.0658 11.2683 10.3053 10.5854C9.54481 9.90264 9.07329 8.94755 8.98922 7.91969C8.18541 7.74772 7.46422 7.29999 6.94666 6.6516C6.42909 6.00322 6.14662 5.19364 6.14664 4.35866V1.48217C6.14664 1.28747 6.18438 1.09467 6.25771 0.914794C6.33103 0.734918 6.4385 0.571491 6.57398 0.433848C6.70946 0.296206 6.87029 0.187046 7.04728 0.112605C7.22428 0.0381633 7.41397 -0.000100167 7.60551 1.96927e-07H8.31277C8.41148 1.95432e-07 8.50921 0.0197618 8.6004 0.0581567C8.69159 0.0965517 8.77445 0.152828 8.84424 0.223773C8.91403 0.294717 8.9694 0.378941 9.00717 0.471634C9.04494 0.564328 9.06438 0.663676 9.06438 0.764007C9.06438 0.864338 9.04494 0.963686 9.00717 1.05638C8.9694 1.14907 8.91403 1.2333 8.84424 1.30424C8.77445 1.37519 8.69159 1.43146 8.6004 1.46986C8.50921 1.50825 8.41148 1.52801 8.31277 1.52801ZM1.38296 1.70679H5.01923V3.2348H1.50246V13.2624H16.4196V11.2997L16.4888 11.2309C17.2679 10.4387 17.7714 9.40971 17.9228 8.30017V13.3846C17.9228 13.5692 17.8871 13.752 17.8176 13.9226C17.7481 14.0932 17.6462 14.2481 17.5178 14.3787C17.3893 14.5092 17.2369 14.6128 17.0691 14.6834C16.9013 14.754 16.7215 14.7904 16.5399 14.7904H10.3271L10.9051 16.472H12.7503C12.9496 16.472 13.1408 16.5525 13.2817 16.6958C13.4227 16.839 13.5019 17.0334 13.5019 17.236C13.5019 17.4386 13.4227 17.6329 13.2817 17.7762C13.1408 17.9195 12.9496 18 12.7503 18H5.17181C5.07311 18 4.97537 17.9802 4.88418 17.9418C4.79299 17.9034 4.71013 17.8472 4.64034 17.7762C4.57055 17.7053 4.51518 17.6211 4.47741 17.5284C4.43964 17.4357 4.4202 17.3363 4.4202 17.236C4.4202 17.1357 4.43964 17.0363 4.47741 16.9436C4.51518 16.8509 4.57055 16.7667 4.64034 16.6958C4.71013 16.6248 4.79299 16.5685 4.88418 16.5301C4.97537 16.4917 5.07311 16.472 5.17181 16.472H7.017L7.59574 14.7904H1.38296C1.20134 14.7904 1.02151 14.754 0.853722 14.6834C0.685934 14.6128 0.533478 14.5092 0.405059 14.3787C0.145704 14.115 0 13.7575 0 13.3846V3.11256C0 2.73973 0.145704 2.38217 0.405059 2.11853C0.664413 1.8549 1.01617 1.70679 1.38296 1.70679Z" fill="#6B7280" />
                                                                </svg>

                                                                Video visit
                                                            </div>
                                                        )
                                                    }
                                                </>
                                            )
                                        }

                                    </div>
                                    <div className={s.desInfo}>
                                        <div className={s.desc}>
                                            {item.description}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.right}>
                                    <span className={s.icon}>
                                        <img src={icon} alt="icon" />
                                    </span>
                                </div>
                            </div>
                            <div className={s.bottom}>
                                <span className={s.more}>
                                    Learn more
                                </span>
                                <span className={s.booked}>
                                    {item.recentBooked || 66}+ recently booked
                                </span>
                            </div>
                        </div>
                    );
                }) : ''
            }
        </div>
    );
};

export default ServiceSelection;
